import React from "react";
import RetailerOption from "./RetailerOptions";

const steps = [
  {
    step: 1,
    title: "Login/ Sign Up",
    description: "Create your free account in just a few steps.",
  },
  {
    step: 2,
    title: "Browse Products",
    description:
      "Access a wide range of grocery products from trusted suppliers.",
  },
  {
    step: 3,
    title: "Place Orders",
    description:
      "Use our intuitive platform to place orders, track shipments, and manage payments securely.",
  },
  {
    step: 4,
    title: "Receive and Sell",
    description:
      "Get your orders delivered swiftly to keep your shelves stocked.",
  },
];

const RetailerOptionsList: React.FC = () => {
  return (
    <div className="wholesaler-options">
      {steps.map(({ step, title, description }) => (
        <RetailerOption
          key={step}
          step={step}
          title={title}
          description={description}
        />
      ))}
    </div>
  );
};

export default RetailerOptionsList;
